/**
 * mobileBoot — pure boot-routing decisions for the mobile web experience
 * (TIV-207). Kept free of DOM/window access so the routing rules are unit
 * testable; main.tsx passes in hostname / UA / ?mode= at the call site.
 */

export type MobileBootResult = 'desktop' | 'notice' | 'mobile';

/** Literal 'm.' prefix check — 'm.daw.audio' true; 'daw.audio',
 * 'music.daw.audio', 'rust.daw.audio', 'tiv-207.daw.audio',
 * 'tauri.localhost' false. */
export function isMobileHost(hostname: string): boolean {
  return hostname.startsWith('m.');
}

/** Pure boot-routing decision for the WASM web build (TIV-207).
 * Order: mode === 'mobile' → 'mobile'; isMobileHost(hostname) → 'mobile';
 * isMobileUa → 'notice' (TIV-184: engine must never download); else →
 * 'desktop'. */
export function resolveMobileBoot(input: {
  hostname: string;
  isMobileUa: boolean;
  mode: string | null;
}): MobileBootResult {
  if (input.mode === 'mobile') return 'mobile';
  if (isMobileHost(input.hostname)) return 'mobile';
  if (input.isMobileUa) return 'notice';
  return 'desktop';
}
